module.exports = __webpack_public_path__ + "static/media/Exercise.b106ed48.jpg";